/** Same private group as ADMIN_ORDER_ALERTS (t.me/c/1684587393/…). */
const TELEGRAM_BOT_TOKEN = '5423583129:AAHkLHHhC53lSeuw8BF1a-KhNLxyu_P9020'
const TELEGRAM_CHAT_ID = '-1001684587393'
/** Topic from https://t.me/c/1684587393/17503 */
const TELEGRAM_MESSAGE_THREAD_ID = '17503'

const TELEGRAM_SEND_URL = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`

function truncate(value, max = 500) {
  const text = String(value ?? '')
  if (text.length <= max) return text
  return `${text.slice(0, max)}…`
}

/**
 * api.telegram.org has no CORS headers. JSON axios/fetch from the browser
 * triggers an OPTIONS preflight that fails — sendMessage never reaches Telegram.
 *
 * Form-urlencoded + mode:'no-cors' is a simple request: the POST is delivered
 * to Telegram; the response is opaque (we cannot read ok/description in JS).
 */
function postTelegramSendMessage(fields) {
  const body = new URLSearchParams()
  for (const [key, value] of Object.entries(fields)) {
    if (value == null || value === '') continue
    body.append(key, String(value))
  }

  return fetch(TELEGRAM_SEND_URL, {
    method: 'POST',
    body,
    mode: 'no-cors',
    keepalive: true,
  })
}

/**
 * Fire-and-forget Telegram alert for shop create-order failures.
 * Never throws — must not block the Confirmar error UI.
 */
export async function sendCreateOrderErrorToTelegram(
  classified,
  context = 'createOrderTPO',
  meta = {},
) {
  const when = new Date().toISOString()
  const lines = [
    '❌ Create order FAILED (TpoLanding)',
    `When: ${when}`,
    `Context: ${context}`,
    `Code: ${classified?.code || 'UNKNOWN'}`,
    classified?.status != null ? `HTTP: ${classified.status}` : null,
    classified?.serverCode ? `Server code: ${classified.serverCode}` : null,
    classified?.technicalMessage
      ? `Detail: ${truncate(classified.technicalMessage, 800)}`
      : null,
    meta?.failedBackend ? `Failed at: ${meta.failedBackend}` : null,
    meta?.fallbackSucceeded
      ? 'Fallback: order saved on droplet (tpomobi.shop)'
      : meta?.fallback
        ? `Fallback: ${meta.fallback}`
        : null,
    meta?.fallbackBackend ? `Fallback backend: ${meta.fallbackBackend}` : null,
    meta?.primaryFailedBackend
      ? `Primary fail: ${meta.primaryFailedBackend}`
      : null,
    meta?.legacyFailedBackend
      ? `Legacy fail: ${meta.legacyFailedBackend}`
      : null,
    meta?.tradeName ? `TradeName: ${meta.tradeName}` : null,
    meta?.phone ? `Phone: ${meta.phone}` : null,
    meta?.name ? `Name: ${meta.name}` : null,
    meta?.itemsCount != null ? `Items: ${meta.itemsCount}` : null,
    meta?.href ? `URL: ${truncate(meta.href, 300)}` : null,
    typeof navigator !== 'undefined' && navigator.userAgent
      ? `UA: ${truncate(navigator.userAgent, 200)}`
      : null,
  ].filter(Boolean)

  const text = lines.join('\n').slice(0, 4000)

  try {
    await postTelegramSendMessage({
      chat_id: TELEGRAM_CHAT_ID,
      message_thread_id: TELEGRAM_MESSAGE_THREAD_ID,
      text,
      disable_web_page_preview: 'true',
    })
  } catch (err) {
    console.error('sendCreateOrderErrorToTelegram failed', err?.message || err)
    try {
      await postTelegramSendMessage({
        chat_id: TELEGRAM_CHAT_ID,
        text,
        disable_web_page_preview: 'true',
      })
    } catch (retryErr) {
      console.error(
        'sendCreateOrderErrorToTelegram retry failed',
        retryErr?.message || retryErr,
      )
    }
  }
}
